// import React, { useEffect, useState } from "react";
// import { Splide, SplideSlide } from "@splidejs/react-splide";
// import "@splidejs/react-splide/css";

// //const API_URL = "http://localhost:8000/certificate_result";
// //const API_URL_FOLDER = "http://localhost:8000";
// const API_URL = "https://display-admin.iskconattapur.com/certificate_result";
// const API_URL_FOLDER = "https://display-admin.iskconattapur.com";

// const getCurrentDate = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0]; // Formats as YYYY-MM-DD
// };

// export default function DonationSlider() {
//   const [allFolders, setAllFolders] = useState([]);
//   const [currentFolderIndex, setCurrentFolderIndex] = useState(0);
//   const [currentImages, setCurrentImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isTransitioning, setIsTransitioning] = useState(false);

//   // Fetch all folders for current date
//   const fetchFolders = async () => {
//     try {
//       const folderName = getCurrentDate();
//       const response = await fetch(`${API_URL_FOLDER}/fetch_folder/${folderName}/folders`);
      
//       if (!response.ok) {
//         // If folders endpoint doesn't exist, fallback to direct image fetch
//         return fetchImagesDirectly();
//       }
      
//       const folders = await response.json();
      
//       if (folders && folders.length > 0) {
//         setAllFolders(folders.sort()); // Sort folders alphabetically
//         return true;
//       } else {
//         return fetchImagesDirectly();
//       }
//     } catch (error) {
//       console.error("Error fetching folders:", error);
//       return fetchImagesDirectly();
//     }
//   };

//   // Fallback: fetch images directly from date folder (original behavior)
//   const fetchImagesDirectly = async () => {
//     try {
//       const folderName = getCurrentDate();
//       const response = await fetch(`${API_URL}/${folderName}/`);
//       const data = await response.json();
      
//       if (data && data.length > 0) {
//         const imageData = data.map((file) => ({
//           src: `${API_URL}/${folderName}/${encodeURIComponent(file)}`,
//           name: `Certificate for ${file.split(".")[0]}`,
//         }));
        
//         setCurrentImages(imageData);
//         setAllFolders(['default']); // Single default folder
//       }
      
//       setLoading(false);
//       return true;
//     } catch (error) {
//       console.error("Error fetching images directly:", error);
//       setLoading(false);
//       return false;
//     }
//   };

//   // Fetch images from specific folder
//   const fetchImagesFromFolder = async (folderName) => {
//     try {
//       const dateFolder = getCurrentDate();
//       const response = await fetch(`${API_URL}/${dateFolder}/${folderName}/`);
//       const data = await response.json();
      
//       if (data && data.length > 0) {
//         const imageData = data.map((file) => ({
//           src: `${API_URL}/${dateFolder}/${folderName}/${encodeURIComponent(file)}`,
//           name: `Certificate for ${file.split(".")[0]}`,
//           folder: folderName
//         }));
        
//         return imageData;
//       }
      
//       return [];
//     } catch (error) {
//       console.error(`Error fetching images from folder ${folderName}:`, error);
//       return [];
//     }
//   };

//   // Load images from current folder
//   const loadCurrentFolderImages = async () => {
//     if (allFolders.length === 0) return;
    
//     setIsTransitioning(true);
//     const folderName = allFolders[currentFolderIndex];
    
//     let images;
//     if (folderName === 'default') {
//       // Already loaded in fetchImagesDirectly
//       images = currentImages;
//     } else {
//       images = await fetchImagesFromFolder(folderName);
//     }
    
//     setCurrentImages(images);
//     setIsTransitioning(false);
//     setLoading(false);
//   };

//   // Initialize folders and images
//   const initializeData = async () => {
//     setLoading(true);
//     const success = await fetchFolders();
    
//     if (success && allFolders.length === 0) {
//       // Wait for folders to be set in state
//       setTimeout(() => {
//         if (allFolders.length > 0) {
//           loadCurrentFolderImages();
//         }
//       }, 100);
//     }
//   };

//   // Handle slide end - move to next folder when current folder slides complete
//   const handleSlideEnd = (splide) => {
//     const currentSlideIndex = splide.index;
//     const totalSlides = currentImages.length;
    
//     // Check if we've completed all slides in current folder
//     if (currentSlideIndex === totalSlides - 1) {
//       setTimeout(() => {
//         moveToNextFolder();
//       }, 3000); // Wait 3 seconds before moving to next folder
//     }
//   };

//   // Move to next folder
//   const moveToNextFolder = () => {
//     if (allFolders.length <= 1) return;
    
//     const nextIndex = (currentFolderIndex + 1) % allFolders.length;
//     setCurrentFolderIndex(nextIndex);
//   };

//   // Effect to load images when folder changes
//   useEffect(() => {
//     if (allFolders.length > 0) {
//       loadCurrentFolderImages();
//     }
//   }, [currentFolderIndex, allFolders]);

//   // Effect to refresh data periodically
//   useEffect(() => {
//     initializeData();
    
//     const interval = setInterval(() => {
//       initializeData();
//     }, 30000); // Check for new folders/images every 30 seconds
    
//     return () => clearInterval(interval);
//   }, []);

//   if (loading) {
//     return (
//       <div className="text-white text-center mt-10 flex flex-col items-center">
//         <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mb-4"></div>
//         <p>Loading certificates...</p>
//         {allFolders.length > 0 && (
//           <p className="text-sm mt-2">
//             Found {allFolders.length} folder{allFolders.length > 1 ? 's' : ''}
//           </p>
//         )}
//       </div>
//     );
//   }

//   if (!loading && currentImages.length === 0) {
//     return (
//       <div className="w-full h-full p-10 flex justify-center items-center">
//         <img
//           src="/placeholder.jpg"
//           alt="ISKCON Hare Krishna"
//           className="max-w-full max-h-full object-contain rounded-xl shadow-lg"
//         />
//       </div>
//     );
//   }

//   return (
//     <div className="w-screen h-screen flex justify-center items-center relative">

      
//       {/* Loading overlay for folder transitions */}
//       {isTransitioning && (
//         <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
//           <div className="text-white text-lg">
//             Loading folder: {allFolders[currentFolderIndex]}...
//           </div>
//         </div>
//       )}
      
//       <Splide
//         key={`${currentFolderIndex}-${currentImages.length}`} // Force re-render on folder change
//         options={{
//           type: "loop",
//           autoplay: true,
//           interval: 8000,
//           pauseOnHover: false,
//           pauseOnFocus: false,
//           arrows: false,
//           pagination: false,
//           easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
//           speed: 1100,
//           resetProgress: false,
//         }}
//         onMoved={(splide) => handleSlideEnd(splide)}
//         className="overflow-hidden w-screen h-full flex"
//       >
//         {currentImages.map((image, index) => (
//           <SplideSlide key={`${currentFolderIndex}-${index}`}>
//             <div
//               className="w-full h-full flex justify-center items-center"
//               style={{
//                 backgroundImage: `url('${image.src}')`,
//                 backgroundSize: "contain",
//                 backgroundPosition: "center",
//                 backgroundRepeat: "no-repeat",
//                 backgroundAttachment: "fixed",
//                 width: "100vw",
//                 height: "100vh",
//               }}
//             >
              
//             </div>
//           </SplideSlide>
//         ))}
//       </Splide>
//     </div>
//   );
// }


import React, { useEffect, useState, useCallback, useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

//const API_URL = "http://localhost:8000/certificate_result";
//const API_URL_FOLDER = "http://localhost:8000";
const API_URL = "https://display-admin.iskconbhiwandi.org/certificate_result";
const API_URL_FOLDER = "https://display-admin.iskconbhiwandi.org";

// const getCurrentDate = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0]; // Formats as YYYY-MM-DD
// };

// export default function DonationSlider() {
//   const [allFolders, setAllFolders] = useState([]);
//   const [currentFolderIndex, setCurrentFolderIndex] = useState(0);
//   const [currentImages, setCurrentImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  
//   // Store all folder data to avoid repeated API calls
//   const [folderImageMap, setFolderImageMap] = useState(new Map());
  
//   // Refs to prevent unnecessary re-renders and API calls
//   const isInitialized = useRef(false);
//   const isLoadingImages = useRef(false);
//   const splideRef = useRef(null);

//   // Fetch all folders for current date - ONE TIME ONLY
//   const fetchAllFoldersOnce = useCallback(async () => {
//     try {
//       const folderName = getCurrentDate();
//       const response = await fetch(`${API_URL_FOLDER}/fetch_folder/${folderName}/folders`);
      
//       if (!response.ok) {
//         throw new Error('Folders endpoint not available');
//       }
      
//       const folders = await response.json();
      
//       if (folders && folders.length > 0) {
//         const sortedFolders = folders.sort(); // Sort folders alphabetically
//         console.log(`Found ${sortedFolders.length} folders:`, sortedFolders);
//         return sortedFolders;
//       } else {
//         return ['default']; // Will trigger fallback
//       }
//     } catch (error) {
//       console.error("Error fetching folders:", error);
//       return ['default']; // Will trigger fallback
//     }
//   }, []);

//   // Fetch images directly from date folder (fallback)
//   const fetchImagesDirectly = useCallback(async () => {
//     try {
//       const folderName = getCurrentDate();
//       const response = await fetch(`${API_URL}/${folderName}/`);
//       const data = await response.json();
      
//       if (data && data.length > 0) {
//         const imageData = data.map((file) => ({
//           src: `${API_URL}/${folderName}/${encodeURIComponent(file)}`,
//           name: `Certificate for ${file.split(".")[0]}`,
//         }));
        
//         return imageData;
//       }
      
//       return [];
//     } catch (error) {
//       console.error("Error fetching images directly:", error);
//       return [];
//     }
//   }, []);

//   // Fetch images from specific folder
//   const fetchImagesFromFolder = useCallback(async (folderName) => {
//     try {
//       const dateFolder = getCurrentDate();
//       const response = await fetch(`${API_URL}/${dateFolder}/${folderName}/`);
//       const data = await response.json();
      
//       if (data && data.length > 0) {
//         const imageData = data.map((file) => ({
//           src: `${API_URL}/${dateFolder}/${folderName}/${encodeURIComponent(file)}`,
//           name: `Certificate for ${file.split(".")[0]}`,
//           folder: folderName
//         }));
        
//         return imageData;
//       }
      
//       return [];
//     } catch (error) {
//       console.error(`Error fetching images from folder ${folderName}:`, error);
//       return [];
//     }
//   }, []);

//   // Pre-fetch and cache images for a specific folder
//   const cacheImagesForFolder = useCallback(async (folderName, isDefault = false) => {
//     // Check if already cached
//     if (folderImageMap.has(folderName)) {
//       console.log(`Images for folder ${folderName} already cached`);
//       return folderImageMap.get(folderName);
//     }

//     console.log(`Caching images for folder: ${folderName}`);
    
//     let images = [];
    
//     if (isDefault) {
//       images = await fetchImagesDirectly();
//     } else {
//       images = await fetchImagesFromFolder(folderName);
//     }
    
//     // Cache the images
//     setFolderImageMap(prev => {
//       const newMap = new Map(prev);
//       newMap.set(folderName, images);
//       return newMap;
//     });
    
//     console.log(`Cached ${images.length} images for folder: ${folderName}`);
//     return images;
//   }, [folderImageMap, fetchImagesDirectly, fetchImagesFromFolder]);

//   // Load images from cache or fetch if not cached
//   const loadImagesForCurrentFolder = useCallback(async (folderName, isDefault = false) => {
//     if (isLoadingImages.current) {
//       console.log('Already loading images, skipping...');
//       return;
//     }
    
//     isLoadingImages.current = true;
//     setIsTransitioning(true);
    
//     console.log(`Loading images for current folder: ${folderName}`);
    
//     try {
//       let images = [];
      
//       // Check if images are cached
//       if (folderImageMap.has(folderName)) {
//         images = folderImageMap.get(folderName);
//         console.log(`Using cached images for folder: ${folderName} (${images.length} images)`);
//       } else {
//         // Fetch and cache if not available
//         images = await cacheImagesForFolder(folderName, isDefault);
//       }
      
//       setCurrentImages(images);
//       setCurrentSlideIndex(0); // Reset slide index for new folder
      
//     } catch (error) {
//       console.error('Error loading images:', error);
//       setCurrentImages([]);
//     } finally {
//       setIsTransitioning(false);
//       isLoadingImages.current = false;
//     }
//   }, [folderImageMap, cacheImagesForFolder]);

//   // Pre-fetch images for next folder when current folder slides complete
//   const preFetchNextFolderImages = useCallback(async () => {
//     if (allFolders.length <= 1) return;
    
//     const nextIndex = (currentFolderIndex + 1) % allFolders.length;
//     const nextFolderName = allFolders[nextIndex];
//     const isDefault = nextFolderName === 'default';
    
//     // Pre-fetch next folder images if not already cached
//     if (!folderImageMap.has(nextFolderName)) {
//       console.log(`Pre-fetching images for next folder: ${nextFolderName}`);
//       await cacheImagesForFolder(nextFolderName, isDefault);
//     }
//   }, [allFolders, currentFolderIndex, folderImageMap, cacheImagesForFolder]);

//   // Initialize data - called only once at startup
//   const initializeData = useCallback(async () => {
//     if (isInitialized.current) {
//       console.log('Already initialized, skipping...');
//       return;
//     }
    
//     console.log('Initializing data - ONE TIME SETUP...');
//     setLoading(true);
//     isInitialized.current = true;
    
//     try {
//       // Fetch all folders once
//       const folders = await fetchAllFoldersOnce();
//       setAllFolders(folders);
//       setCurrentFolderIndex(0);
      
//       // Load first folder images
//       const firstFolderName = folders[0];
//       const isDefault = firstFolderName === 'default';
//       await loadImagesForCurrentFolder(firstFolderName, isDefault);
      
//       // Pre-fetch next folder if exists
//       if (folders.length > 1) {
//         const secondFolderName = folders[1];
//         const isSecondDefault = secondFolderName === 'default';
//         await cacheImagesForFolder(secondFolderName, isSecondDefault);
//       }
      
//     } catch (error) {
//       console.error('Initialization error:', error);
//       // Fallback to default
//       setAllFolders(['default']);
//       setCurrentFolderIndex(0);
//       await loadImagesForCurrentFolder('default', true);
//     }
    
//     setLoading(false);
//   }, [fetchAllFoldersOnce, loadImagesForCurrentFolder, cacheImagesForFolder]);

//   // Move to next folder
//   const moveToNextFolder = useCallback(async () => {
//     if (allFolders.length <= 1) return;
    
//     const nextIndex = (currentFolderIndex + 1) % allFolders.length;
//     const nextFolderName = allFolders[nextIndex];

//     console.log("====>>>> nextIndex", nextIndex)
//     console.log("====>>>> allFolders.length", allFolders.length)
    
//     // Check if we're going back to first folder (cycle complete)
//     if (nextIndex === allFolders.length - 1) {
//       window.location.reload(true)
//       console.log(`🔄 All folders completed! Restarting from first folder: ${nextFolderName}`);
//     } else {
//       console.log(`Moving from folder ${currentFolderIndex} (${allFolders[currentFolderIndex]}) to ${nextIndex} (${nextFolderName})`);
//     }
    
//     // Pre-fetch images for the folder after next
//     const folderAfterNext = (nextIndex + 1) % allFolders.length;
//     const folderAfterNextName = allFolders[folderAfterNext];
//     const isDefault = folderAfterNextName === 'default';
    
//     // Pre-fetch next-next folder images
//     if (!folderImageMap.has(folderAfterNextName)) {
//       console.log(`Pre-fetching images for folder after next: ${folderAfterNextName}`);
//       cacheImagesForFolder(folderAfterNextName, isDefault); // Don't await - run in background
//     }
    
//     setCurrentFolderIndex(nextIndex);
//   }, [allFolders, currentFolderIndex, folderImageMap, cacheImagesForFolder]);

//   // Handle slide moved - track current slide and move to next folder when done
//   const handleSlideMoved = useCallback((splide, newIndex) => {
//     setCurrentSlideIndex(newIndex);
//     const totalSlides = currentImages.length;
    
//     console.log(`Slide moved to: ${newIndex + 1}/${totalSlides} in folder: ${allFolders[currentFolderIndex]}`);
    
//     // Check if we've reached the last slide of current folder
//     if (newIndex === totalSlides - 1) {
//       console.log(`Last slide of folder ${allFolders[currentFolderIndex]} reached`);
      
//       // Pre-fetch next folder images if not cached and then move
//       setTimeout(async () => {
//         await preFetchNextFolderImages();
//         console.log('Moving to next folder...');
//         moveToNextFolder();
//       }, 8000 + 1100); // interval + speed time
//     }
//   }, [currentImages.length, allFolders, currentFolderIndex, preFetchNextFolderImages, moveToNextFolder]);

//   // Effect to initialize data on mount - RUNS ONLY ONCE
//   useEffect(() => {
//     initializeData();
//   }, []); // Empty dependency array - runs only once

//   // Effect to load images when folder index changes
//   useEffect(() => {
//     if (allFolders.length > 0 && currentFolderIndex >= 0 && !loading) {
//       const folderName = allFolders[currentFolderIndex];
//       const isDefault = folderName === 'default';
      
//       console.log(`Folder index changed to: ${currentFolderIndex} (${folderName})`);
//       loadImagesForCurrentFolder(folderName, isDefault);
//     }
//   }, [currentFolderIndex, allFolders, loading, loadImagesForCurrentFolder]);

//   if (loading) {
//     return (
//       <div className="text-white text-center mt-10 flex flex-col items-center">
//         <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mb-4"></div>
//         <p>Setting up slideshow...</p>
//         {allFolders.length > 0 && (
//           <p className="text-sm mt-2">
//             Found {allFolders.length} folder{allFolders.length > 1 ? 's' : ''}
//           </p>
//         )}
//       </div>
//     );
//   }

//   if (!loading && currentImages.length === 0) {
//     return (
//       <div className="w-full h-full p-10 flex justify-center items-center">
//         <img
//           src="/placeholderbh.jpg"
//           alt="ISKCON Hare Krishna"
//           className="max-w-full max-h-full object-contain rounded-xl shadow-lg"
//         />
//       </div>
//     );
//   }

//   return (
//     <div className="w-screen h-screen flex justify-center items-center relative">
     
      
//       {currentImages.length > 0 && !isTransitioning && (
//         <Splide
//           ref={splideRef}
//           key={`folder-${currentFolderIndex}-${currentImages.length}`}
//           options={{
//             type: "slide",
//             autoplay: true,
//             interval: 8000, // 8 seconds per slide
//             pauseOnHover: false,
//             pauseOnFocus: false,
//             arrows: false,
//             pagination: false,
//             easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
//             speed: 1100,
//             resetProgress: false,
//             rewind: false,
//             start: 0,
//           }}
//           onMoved={handleSlideMoved}
//           className="overflow-hidden w-screen h-full flex"
//         >
//           {currentImages.map((image, index) => (
//             <SplideSlide key={`img-${currentFolderIndex}-${index}`}>
//               <div
//                 className="w-full h-full flex justify-center items-center"
//                 style={{
//                   backgroundImage: `url('${image.src}')`,
//                   backgroundSize: "contain",
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   backgroundAttachment: "fixed",
//                   width: "100vw",
//                   height: "100vh",
//                 }}
//               />
//             </SplideSlide>
//           ))}
//         </Splide>
//       )}
//     </div>
//   );
// }



const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export default function DonationSlider() {
  const [allFolders, setAllFolders] = useState([]);
  const [currentFolderIndex, setCurrentFolderIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const [folderImageMap, setFolderImageMap] = useState(new Map());

  const isInitialized = useRef(false);
  const isLoadingImages = useRef(false);

  // ✅ Fetch folders
  const fetchAllFoldersOnce = useCallback(async () => {
    try {
      const folderName = getCurrentDate();
      const res = await fetch(
        `${API_URL_FOLDER}/fetch_folder/${folderName}/folders`
      );

      if (!res.ok) throw new Error();

      const folders = await res.json();

      return folders.length ? folders.sort() : ["default"];
    } catch {
      return ["default"];
    }
  }, []);

  // ✅ Fetch images (default)
  const fetchImagesDirectly = useCallback(async () => {
    try {
      const folderName = getCurrentDate();
      const res = await fetch(`${API_URL}/${folderName}/`);
      const data = await res.json();

      return data.map((file) => ({
        src: `${API_URL}/${folderName}/${encodeURIComponent(file)}`,
      }));
    } catch {
      return [];
    }
  }, []);

  // ✅ Fetch images (folder)
  const fetchImagesFromFolder = useCallback(async (folderName) => {
    try {
      const dateFolder = getCurrentDate();
      const res = await fetch(`${API_URL}/${dateFolder}/${folderName}/`);
      const data = await res.json();

      return data.map((file) => ({
        src: `${API_URL}/${dateFolder}/${folderName}/${encodeURIComponent(
          file
        )}`,
      }));
    } catch {
      return [];
    }
  }, []);

  // ✅ Cache images
  const cacheImagesForFolder = useCallback(
    async (folderName, isDefault = false) => {
      if (folderImageMap.has(folderName)) {
        return folderImageMap.get(folderName);
      }

      const images = isDefault
        ? await fetchImagesDirectly()
        : await fetchImagesFromFolder(folderName);

      setFolderImageMap((prev) => {
        const map = new Map(prev);
        map.set(folderName, images);
        return map;
      });

      return images;
    },
    [folderImageMap, fetchImagesDirectly, fetchImagesFromFolder]
  );

  // ✅ Load images
  const loadImagesForCurrentFolder = useCallback(
    async (folderName, isDefault = false) => {
      if (isLoadingImages.current) return;

      isLoadingImages.current = true;
      setIsTransitioning(true);

      let images = [];

      if (folderImageMap.has(folderName)) {
        images = folderImageMap.get(folderName);
      } else {
        images = await cacheImagesForFolder(folderName, isDefault);
      }

      setCurrentImages(images);

      setIsTransitioning(false);
      isLoadingImages.current = false;
    },
    [folderImageMap, cacheImagesForFolder]
  );

  // ✅ Initialize
  const initializeData = useCallback(async () => {
    if (isInitialized.current) return;

    isInitialized.current = true;
    setLoading(true);

    const folders = await fetchAllFoldersOnce();
    setAllFolders(folders);

    const first = folders[0];
    await loadImagesForCurrentFolder(first, first === "default");

    setLoading(false);
  }, [fetchAllFoldersOnce, loadImagesForCurrentFolder]);

  // ✅ FIXED: Move to next folder (skip empty + loop)
  const moveToNextFolder = useCallback(async () => {
    if (allFolders.length <= 1) return;

    let nextIndex = currentFolderIndex;

    for (let i = 0; i < allFolders.length; i++) {
      nextIndex = (nextIndex + 1) % allFolders.length;
      const folder = allFolders[nextIndex];

      const isDefault = folder === "default";

      let images = [];

      if (folderImageMap.has(folder)) {
        images = folderImageMap.get(folder);
      } else {
        images = await cacheImagesForFolder(folder, isDefault);
      }

      if (images.length > 0) {
        setCurrentFolderIndex(nextIndex);
        return;
      }
    }

    console.log("No valid folders with images found");
  }, [allFolders, currentFolderIndex, folderImageMap, cacheImagesForFolder]);

  // ✅ Slide end → move folder
  const handleSlideMoved = useCallback(
    (splide, newIndex) => {
      const total = currentImages.length;

      if (newIndex === total - 1) {
        setTimeout(() => {
          moveToNextFolder();
        }, 9000);
      }
    },
    [currentImages.length, moveToNextFolder]
  );

  useEffect(() => {
    initializeData();
  }, []);

  useEffect(() => {
    if (allFolders.length > 0 && !loading) {
      const folder = allFolders[currentFolderIndex];
      loadImagesForCurrentFolder(folder, folder === "default");
    }
  }, [currentFolderIndex, allFolders, loading, loadImagesForCurrentFolder]);

  // ✅ UI states
  if (loading) {
    return (
      <div className="text-white text-center mt-10">
        Loading slideshow...
      </div>
    );
  }

  if (!currentImages.length) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <img src="/placeholderbh.jpg" className="max-w-full max-h-full" />
      </div>
    );
  }

  return (
    <div className="w-screen h-screen flex justify-center items-center">
      {!isTransitioning && (
        <Splide
          key={`${currentFolderIndex}-${currentImages.length}`}
          options={{
            type: "loop",
            autoplay: true,
            interval: 8000,
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            speed: 1100,
          }}
          onMoved={handleSlideMoved}
          className="w-screen h-full"
        >
          {currentImages.map((img, i) => (
            <SplideSlide key={img.src}>
              <div
                className="w-full h-full"
                style={{
                  backgroundImage: `url('${img.src}')`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100vw",
                  height: "100vh",
                }}
              />
            </SplideSlide>
          ))}
        </Splide>
      )}
    </div>
  );
}